const actions = {
  CREATE_PRODUCT: 'CREATE_PRODUCT',
  CREATE_PRODUCT_ENDED: 'CREATE_PRODUCT_ENDED',
  CREATE_PRODUCT_CATEGORY: 'CREATE_PRODUCT_CATEGORY',
  CREATE_PRODUCT_CATEGORY_ENDED: 'CREATE_PRODUCT_CATEGORY_ENDED',
  SEARCH_PRODUCTS: 'SEARCH_PRODUCTS',
  SEARCH_PRODUCTS_ENDED: 'SEARCH_PRODUCTS_ENDED',
  SEARCH_PRODUCT_CATEGORIES: 'SEARCH_PRODUCT_CATEGORIES',
  SEARCH_PRODUCT_CATEGORIES_ENDED: 'SEARCH_PRODUCT_CATEGORIES_ENDED',
  FIND_PRODUCT_CATEGORY: 'FIND_PRODUCT_CATEGORY',
  FIND_PRODUCT_CATEGORY_ENDED: 'FIND_PRODUCT_CATEGORY_ENDED',
  UPDATE_PRODUCT: 'UPDATE_PRODUCT',
  UPDATE_PRODUCT_ENDED: 'UPDATE_PRODUCT_ENDED',
  UPDATE_PRODUCT_CATEGORY: 'UPDATE_PRODUCT_CATEGORY',
  UPDATE_PRODUCT_CATEGORY_ENDED: 'UPDATE_PRODUCT_CATEGORY_ENDED',
  DELETE_PRODUCTS: 'DELETE_PRODUCTS',
  DELETE_PRODUCTS_ENDED: 'DELETE_PRODUCTS_ENDED',
  DELETE_PRODUCT_CATEGORIES: 'DELETE_PRODUCT_CATEGORIES',
  DELETE_PRODUCT_CATEGORIES_ENDED: 'DELETE_PRODUCT_CATEGORIES_ENDED',
};
export default actions;
